"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _permission = require("@/utils/permission");
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _productInfo = _interopRequireDefault(require("@/components/productInfo"));
var _previewBox = _interopRequireDefault(require("./previewBox"));
var _vuex = require("vuex");
var _debounce = _interopRequireDefault(require("@/libs/debounce"));
var _productEnums = require("@/enums/productEnums");
var _batchAudit = _interopRequireDefault(require("@/views/product/batchAudit.vue"));
var _batchPrice = _interopRequireDefault(require("@/views/product/batchPrice.vue"));
var _public = require("@/libs/public");
var _useProduct2 = require("@/hooks/use-product");
var _product2 = _interopRequireDefault(require("@/mixins/product"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var headerName = [{
  name: '出售中商品',
  type: 1
}, {
  name: '仓库中商品',
  type: 2
}, {
  name: '待审核商品',
  type: 6
}, {
  name: '审核未通过商品',
  type: 7
}];
var _useProduct = (0, _useProduct2.useProduct)(),
  productTypeList = _useProduct.productTypeList;
var _default = exports.default = {
  name: 'ProductList',
  components: {
    BatchAudit: _batchAudit.default,
    BatchPrice: _batchPrice.default,
    infoFrom: _productInfo.default,
    merchantName: _merchantName.default,
    previewBox: _previewBox.default
  },
  mixins: [_product2.default],
  data: function data() {
    return {
      productTypeList: productTypeList,
      //商品类型
      componentKey: 0,
      isAtud: false,
      isShow: false,
      productId: 0,
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'childList',
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: false,
        multiple: false
      },
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false
      },
      isShowSeach: true,
      categoryIdData: [],
      headeNum: [],
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        categoryId: null,
        keywords: '',
        type: '1',
        isSelf: null,
        merId: null,
        isPaidMember: null,
        productType: null
      },
      keywords: '',
      categoryList: [],
      merCateList: [],
      objectUrl: process.env.VUE_APP_BASE_API,
      dialogVisible: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['ID', '商品图', '商品名称', '商品售价', '商品成本价', '商户名称', '销量', '库存', '权重', '审核状态'],
      columnData: ['ID', '商品图', '商品名称', '商品售价', '商品成本价', '商户名称', '销量', '库存', '权重', '审核状态'],
      isIndeterminate: true,
      merchantList: [],
      search: {
        limit: 10,
        page: 1,
        keywords: ''
      },
      loading: false,
      totalPage: 0,
      total: 0,
      keyNum: 0,
      multipleSelection: [],
      checkedIds: [],
      selectedMerId: null,
      previewVisible: false,
      previewProductId: '',
      // 预览商品id
      formData: {
        ficti: 0,
        idList: []
      },
      rankDialogVisible: false,
      rankSubmitting: false,
      rankForm: {
        rank: 0
      },
      isEdit: false,
      editProductId: null
      //dialogVisibleInfo: false //详情
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:product:tabs:headers'])) this.goodHeade();
    if (!localStorage.getItem('merPlatProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
    if ((0, _permission.checkPermi)(['platform:product:page:list'])) this.getList(1);
    if (this.$cache.local.has('goods_stroge')) {
      var cachedColumns = this.$cache.local.getJSON('goods_stroge') || [];
      this.checkedCities = Array.isArray(cachedColumns) ? cachedColumns.map(function (item) {
        return item === '商品成本' ? '商品成本价' : item;
      }) : this.checkedCities;
      if (!this.checkedCities.includes('商品成本价')) this.checkedCities.push('商品成本价');
      if (!this.checkedCities.includes('权重')) this.checkedCities.push('权重');
    }
  },
  computed: _objectSpread(_objectSpread({
    ProductTypeEnum: function ProductTypeEnum() {
      return _productEnums.ProductTypeEnum;
    }
  }, (0, _vuex.mapGetters)(['merPlatProductClassify', 'frontDomain'])), {}, {
    heightBoxs: function heightBoxs() {
      var _this2 = this;
      this.$nextTick(function () {
        // 页面渲染完成后的回调
        return Number(_this2.$refs.headerBox.offsetHeight) - Number(document.documentElement.clientHeight);
      });
    }
  }),
  methods: {
    checkPermi: _permission.checkPermi,
    //搜索
    handleSeachList: function handleSeachList() {
      this.getList(1);
      this.goodHeade();
    },
    //批量审核
    handlebatchAudit: function handlebatchAudit() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.$refs.refBatchAudit.dialogVisible = true;
    },
    //批量改价
    handleBatchPrice: function handleBatchPrice() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      if (!this.selectedMerId) return this.$message.warning('请选择同一供应商的商品');
      this.$refs.refBatchPrice.dialogVisible = true;
    },
    //批量审核提交成功回调
    subBatchAuditSuccess: function subBatchAuditSuccess() {
      this.subSuccess();
    },
    //详情关闭
    onCloseInfo: function onCloseInfo() {
      this.dialogVisibleInfo = false;
      this.isEdit = false;
      this.editProductId = null;
    },
    // 编辑商品保存成功后，弹窗确认是否强制下架
    handleSaveSuccess: function handleSaveSuccess(productId) {
      var _this3 = this;
      this.$modalSure('保存成功，是否强制下架该商品？').then(function () {
        (0, _product.offShellApi)({
          ids: productId.toString()
        }).then(function () {
          _this3.$message.success('强制下架成功');
          _this3.tableFrom.type = '2';
          _this3.subSuccess();
        });
      }).catch(function () {
        _this3.subSuccess();
      });
    },
    //批量增加初始销量
    handleBatchSales: function handleBatchSales() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.dialogVisible = true;
    },
    //批量设置权重
    handleBatchRank: function handleBatchRank() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.rankForm.rank = 0;
      this.rankDialogVisible = true;
    },
    handleRankClose: function handleRankClose() {
      this.rankDialogVisible = false;
      this.rankSubmitting = false;
    },
    submitRank: function submitRank() {
      var _this4 = this;
      var rank = this.rankForm.rank;
      if (rank === null || rank === undefined || rank === '') return this.$message.warning('请输入权重');
      var rows = this.multipleSelection.slice();
      if (!rows.length) return this.$message.warning('请先选择商品');
      this.rankSubmitting = true;
      Promise.all(rows.map(function (row) {
        return (0, _product.updateProductApi)({
          id: row.id,
          ficti: row.ficti || 0,
          rank: rank
        });
      })).then(function () {
        _this4.$message.success('权重设置成功');
        _this4.rankDialogVisible = false;
        _this4.getList(1);
      }).catch(function () {
        _this4.$message.error('部分商品权重设置失败，请重试');
        _this4.getList(1);
      }).finally(function () {
        _this4.rankSubmitting = false;
      });
    },
    /** 提交按钮 */
    submitForm: (0, _debounce.default)(function (formData) {
      var _this5 = this;
      this.$refs[formData].validate(function (valid) {
        if (valid) {
          _this5.formData.idList = _this5.checkedIds;
          (0, _product.productBatchVirtualSalesApi)(_this5.formData).then(function (response) {
            _this5.$modal.msgSuccess('操作成功');
            _this5.getList(1);
            _this5.handleClose();
          });
        }
      });
    }),
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.formData.ficti = 0;
    },
    // 更多下拉菜单
    handleMoreCmd: function handleMoreCmd(cmd, row) {
      switch (cmd) {
        case 'edit':
          this.editProductId = row.id;
          this.handleAudit(row.id, false);
          this.isEdit = true;
          break;
        case 'sales':
          this.handleEdit(row);
          break;
        case 'off':
          this.handleOff(row.id);
          break;
        case 'audit':
          this.handleAudit(row.id, true);
          break;
        case 'review':
          this.$router.push({
            path: '/product/comment',
            query: {
              productSearch: row.name
            }
          });
          break;
      }
    },
    ishttp: function ishttp(url) {
      return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1;
    },
    // 预览：后台展示商品图文详情，无需登录
    handlePreview: function handlePreview(id) {
      this.previewVisible = true;
      this.previewProductId = id;
    },
    getMerId: function getMerId(id) {
      this.tableFrom.merId = id;
      this.subSuccess();
    },
    // 批量下架
    handlebatchOff: function handlebatchOff() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.handleOff(this.checkedIds);
    },
    // 下架
    handleOff: function handleOff(id) {
      var _this6 = this;
      this.$modalSure('强制下架吗').then(function () {
        (0, _product.offShellApi)({
          ids: id.toString()
        }).then(function (res) {
          _this6.$message({
            type: 'success',
            message: '提交成功'
          });
          _this6.subSuccess();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      var data = [];
      var merIds = new Set();
      this.multipleSelection.map(function (item) {
        data.push(item.id);
        if (item.merId) merIds.add(item.merId);
      });
      this.checkedIds = data;
      // 取第一个商户ID作为批量改价的供应商ID
      this.selectedMerId = merIds.size > 0 ? _toConsumableArray(merIds)[0] : null;
    },
    // 显示/隐藏切换
    handleToggleShow: function handleToggleShow(row) {
      var _this7 = this;
      var newShow = !row.isShow;
      (0, _product.productToggleShowApi)(row.id).then(function () {
        _this7.$message.success(newShow ? '已显示' : '已隐藏');
        row.isShow = newShow;
        _this7.getList(1);
      }).catch(function () {
        // 切换失败时不改变状态
      });
    },
    handleEdit: function handleEdit(row) {
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个商品');
      var _this = this;
      this.$modalParserFrom('编辑商品', '平台商品编辑', 1, {
        ficti: row.ficti || '0',
        id: row.id,
        rank: row.rank
      }, function (formValue) {
        _this.submit(formValue, row.id);
      }, this.keyNum += 5);
    },
    submit: function submit(formValue, id) {
      var _this8 = this;
      var data = {
        id: id,
        ficti: formValue.ficti,
        rank: formValue.rank
      };
      (0, _product.updateProductApi)(data).then(function (res) {
        _this8.$message.success('操作成功');
        _this8.$msgbox.close();
        _this8.getList(1);
      }).catch(function () {
        _this8.loading = false;
      });
    },
    // 列表内联更新商品权重（rank）
    handleUpdateRank: function handleUpdateRank(row) {
      var _this9 = this;
      if (row.rank === null || row.rank === undefined || row.rank === '') return;
      (0, _product.updateProductApi)({
        id: row.id,
        ficti: row.ficti || 0,
        rank: row.rank
      }).then(function () {
        _this9.$message.success('权重已更新');
      }).catch(function () {
        _this9.getList(1);
      });
    },
    subSuccess: function subSuccess() {
      this.getList(1);
      this.goodHeade();
      this.dialogVisibleInfo = false;
    },
    handleAudit: function handleAudit(id, c) {
      //this.getProductInfo(id)
      this.isEdit = false;
      this.productId = id;
      this.isShow = true;
      this.isAtud = c;
      this.componentKey += 1;
      this.dialogVisibleInfo = true;
      // this.$refs.infoFrom.dialogVisible = true;

      // this.$refs.infoFrom.getProductInfo(id);
    },
    // 导出
    exports: function exports() {
      (0, _product.productExcelApi)({
        cateId: this.tableFrom.cateId,
        keywords: this.tableFrom.keywords,
        type: this.tableFrom.type
      }).then(function (res) {
        window.location.href = res.fileName;
      });
    },
    // 获取商品表单头数量
    goodHeade: function goodHeade() {
      var _this0 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.type;
      (0, _product.productHeadersApi)(data).then(function (res) {
        res.map(function (item, index) {
          if (item.type === headerName[index].type) item.name = headerName[index].name;
        });
        _this0.headeNum = res;
      }).catch(function (res) {
        if (res && !res.__requestMessageShown) _this0.$message.error(res.message);
      });
    },
    // 列表
    getList: function getList(num) {
      var _this1 = this;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      this.listLoading = true;
      (0, _product.productLstApi)(this.tableFrom).then(function (res) {
        _this1.tableData.data = res.list;
        _this1.tableData.total = res.total;
        _this1.listLoading = false;
      }).catch(function (res) {
        _this1.listLoading = false;
        if (res && !res.__requestMessageShown) _this1.$message.error(res.message);
      });
    },
    reset: function reset() {
      this.keywords = '';
      this.tableFrom.categoryId = null;
      this.tableFrom.keywords = null;
      this.tableFrom.isSelf = null;
      this.tableFrom.merId = null;
      this.tableFrom.isPaidMember = null;
      this.tableFrom.productType = null;
      this.getList(1);
      this.goodHeade();
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(id, type) {
      var _this10 = this;
      this.$modalSure("\u5220\u9664 id \u4E3A ".concat(id, " \u7684\u5546\u54C1")).then(function () {
        var deleteFlag = type == 5 ? 'delete' : 'recycle';
        (0, _product.productDeleteApi)(id, deleteFlag).then(function () {
          _this10.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this10.tableData.data.length, _this10.tableFrom);
          _this10.getList();
          _this10.goodHeade();
        });
      });
    },
    renderHeader: function renderHeader(h) {
      var _this11 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u64CD\u4F5C"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this11.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('goods_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    }
  }
};